import React, { FC } from "react"
import styled from "styled-components"
import { black, splashGradientStart } from "./components/colors"
import { logoName, appLogoNameAlt } from "./sportConfig"

const SplashScreenContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    background-image: ${() => `radial-gradient(${splashGradientStart} 0%, ${black} 100%)`};
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
`
export const SplashScreen: FC = () => {
  return (
    <SplashScreenContainer>
      <img
        style={{ maxWidth: "100%", maxHeight: "100%" }}
        src={logoName}
        alt={appLogoNameAlt}
        width={300}
      />
    </SplashScreenContainer>
  )
}